@if(isLoading) {
<app-loading-indicator />
}

@if(isPrintingPng || isPrintingPdf) {
<app-loading-indicator />
<div class="text-center mb-2" style="color: #719eb6; font-weight: bold;">
  Preparing graph export. Please wait...
</div>
}

@if (showAddAnnotation()) {
  <div class="supervisor-dialog-backdrop"></div>
  <dialog class="supervisor-dialog" open>
    <app-add-annotation
      [patientID]="patientIDAsNumber"
      [annotationToEdit]="annotationToEdit()"
      (close)="onCloseAddAnnotation($event)"
    />
  </dialog>
}

<div class="card mx-5">
  <div class="card-header">
    <div class="row">
      <!-- Graph Options -->
      <div class="col-12 col-lg-6">
        <label style="font-weight: bold; color: #719eb6">Graph Options:</label>

        <!-- Program Graph Type Options -->
        <div class="control-row">
            <div class="control no-margin">
              <label for="selectedProgramGraphType" style="font-weight: bold; color: #719eb6"
                >Graph Type:</label
              >
              <p-dropdown
                styleClass="w-100"
                appendTo="body"
                [options]="programGraphTypes"
                [(ngModel)]="selectedProgramGraphType"
                name="selectedProgramGraphType"
                [checkmark]="true"
                optionLabel="text"
                optionValue="value"
                [showClear]="true"
                placeholder="Select a Graph Type"
                [filter]="true"
                filterBy="text"
                display="chip"
                [showClear]="true"
                [virtualScroll]="true"
                [virtualScrollItemSize]="50"
                [loading]="isLoading"
                optionDisabled="disabled"
                [disabled]="isLoading"
                (onChange)="onProgramGraphTypeChange($event)"
                ><ng-template pTemplate="selectedProgramGraphType" let-selectedOption>
                  <div class="flex align-items-center gap-2">
                    <div>{{ selectedOption.text }}</div>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
        </div>

        <!-- Selected Targets Options -->
        @if(shouldDisplaySelectedTargetsOptions()) {
        <div class="control-row">
          <div class="control no-margin">
            <label for="selectedTargets" style="font-weight: bold; color: #719eb6">Selected Targets:</label>
            <p-multiSelect
              [options]="targets"
              [(ngModel)]="selectedTargets"
              appendTo="body"
              styleClass="w-100"
              optionLabel="text"
              optionValue="value"
              [showClear]="true"
              [virtualScroll]="true"
              [virtualScrollItemSize]="50"
              [loading]="isLoading"
              optionDisabled="disabled"
              [disabled]="isLoading"
              (onChange)="onSelectedTargetsChange($event)"
            ></p-multiSelect>
          </div>
        </div>
        }

        <!-- Target Type Filter Options -->
        @if(shouldDisplayTargetTypeFilterOptions()) {
        <div class="control-row">
          <div class="control no-margin">
            <label for="selectedGraphType" style="font-weight: bold; color: #719eb6"
              >Target Type:</label
            >
            <p-dropdown
              styleClass="w-100"
              appendTo="body"
              [options]="targetTypes"
              [(ngModel)]="selectedTargetType"
              name="selectedTargetType"
              [checkmark]="true"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              placeholder="Select a Target Type to filter by"
              [filter]="true"
              filterBy="label"
              display="chip"
              [showClear]="true"
              [virtualScroll]="true"
              [virtualScrollItemSize]="50"
              [loading]="isLoading"
              optionDisabled="disabled"
              [disabled]="isLoading"
              [hidden]="!shouldDisplayTargetTypeFilterOptions()"
              (onChange)="onTargetTypeChange($event)"
              ><ng-template pTemplate="selectedTargetType" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.label }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        }

        <!-- Target Status Filter Options -->
        @if(shouldDisplayTargetStatusFilterOptions()) {
        <div class="control-row">
          <div class="control no-margin">
            <label for="selectedGraphType" style="font-weight: bold; color: #719eb6"
              >Target Status:</label
            >
            <p-dropdown
              styleClass="w-100"
              appendTo="body"
              [options]="targetStatuses"
              [(ngModel)]="selectedTargetStatus"
              name="selectedTargetStatus"
              [checkmark]="true"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              placeholder="Select a Target Status to filter by"
              [filter]="true"
              filterBy="label"
              display="chip"
              [showClear]="true"
              [virtualScroll]="true"
              [virtualScrollItemSize]="50"
              [loading]="isLoading"
              optionDisabled="disabled"
              [disabled]="isLoading"
              [hidden]="!shouldDisplayTargetStatusFilterOptions()"
              (onChange)="onTargetStatusChange($event)"
              ><ng-template pTemplate="selectedTargetStatus" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.label }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        }

        <!-- Date Options -->
        <div class="control-row">
          <div class="control no-margin">
            <label for="selectedGraphType" style="font-weight: bold; color: #719eb6"
              >Date Options:</label
            >
            <p-dropdown
              [options]="dateOptions"
              [(ngModel)]="dateOption"
              appendTo="body"
              styleClass="w-100"
              optionValue="value"
              optionLabel="label"
              [showClear]="true"
              [disabled]="isLoading"
              [loading]="isLoading"
              (onChange)="onDateOptionChange($event)"
            />
          </div>
        </div>

        <!-- Date Picker -->
        <div class="control-row">
          <div class="d-flex justify-content-between mt-2">
            <div>
              <label
                for="startDatePicker"
                style="font-weight: bold; color: #719eb6; margin-right: 0.5rem"
                >Start Date:</label
              >
              <input
                pInputText
                type="date"
                [ngModel]="formatDateForInput(startDate())"
                (ngModelChange)="onStartDateChange($event)"
                id="startDatePicker"
                [max]="formatDateForInput(endDate())"
              />
            </div>
            <div>
              <label
                for="endDatePicker"
                style="font-weight: bold; color: #719eb6; margin-right: 0.5rem"
                >End Date:</label
              >
              <input
                pInputText
                type="date"
                [ngModel]="formatDateForInput(endDate())"
                (ngModelChange)="onEndDateChange($event)"
                id="endDatePicker"
                [min]="formatDateForInput(startDate())"
              />
            </div>
          </div>
          <div class="mt-2">
            <p-checkbox
              [(ngModel)]="forceGraphPeriod"
              (ngModelChange)="onForceGraphPeriodChange($event)"
              [binary]="true"
              inputId="forceGraphPeriod"
              [disabled]="isLoading"
            ></p-checkbox>
            <label for="forceGraphPeriod" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem; cursor: pointer;">
              Force graph period to selected start/end dates
            </label>
          </div>
        </div>

        <!-- Frequency Options -->
        @if(shouldDisplayGroupingOptions()) {
        <div class="control-row">
          <div class="control no-margin">
            <label for="selectedGraphType" style="font-weight: bold; color: #719eb6"
              >Grouping Options:</label
            >
            <p-dropdown
              [options]="groupingOptions"
              [(ngModel)]="groupingOption"
              appendTo="body"
              styleClass="w-100"
              optionValue="value"
              optionLabel="text"
              (onChange)="onGroupingOptionChange($event)"
            />
          </div>
        </div>
        }

        <!-- Staff Member Options -->
        @if(shouldDisplayStaffMemberOptions()) {
          <div class="control-row">
            <div class="control no-margin">
              <label for="selectedGraphType" style="font-weight: bold; color: #719eb6"
                >Staff Member:</label
              >
              <p-dropdown
                [options]="staffMembers()"
                [(ngModel)]="selectedStaffMember"
                appendTo="body"
                styleClass="w-100"
                optionLabel="FullName"
                (onChange)="onStaffMemberChange($event)"
                [disabled]="isLoading"
                [showClear]="true"
                [loading]="isLoading"
                placeholder="Select a Staff Member to filter by or leave empty to include all staff members"
              />
            </div>
          </div>
        }

        <!-- Display Options -->
        @if(shouldDisplayDisplayOptions()) {
        <div class="row">
          <label for="selectedGraphType" style="font-weight: bold; color: #719eb6"
            >Display Options:</label
          >
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-start">
              <div class="control me-4">
                <label for="seriesDataLabelOption" style="font-weight: bold; color: #719eb6">Series:</label>
                <p-dropdown
                  [options]="seriesDataLabelOptions"
                  [(ngModel)]="seriesDataLabelOption"
                  appendTo="body"
                  styleClass="w-100"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="onSeriesDataLabelOptionChange()"
                  [disabled]="isLoading"
                  [loading]="isLoading"
                  placeholder="Select series display option"
                />
              </div>

              @if(shouldDisplayTrendLineOption()) {
                <div class="d-flex flex-column me-4">
                  <div class="d-flex align-items-center">
                    <p-checkbox
                      class="ms-2"
                      [(ngModel)]="displayTrendLine"
                      (ngModelChange)="onToggleTrendLine()"
                      [binary]="true"
                      [style]="{'color': '#719eb6'}"
                      inputId="displayTrendLine"
                    />
                    <label for="displayTrendLine" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem">Trend Line</label> 
                  </div>
                  @if(displayTrendLine()) {
                    <div class="control mt-2">
                      <label for="trendLineDataLabelOption" style="font-weight: bold; color: #719eb6">Trend Line:</label>
                      <p-dropdown
                        [options]="trendLineDataLabelOptions"
                        [(ngModel)]="trendLineDataLabelOption"
                        appendTo="body"
                        styleClass="w-100"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="onTrendLineDataLabelOptionChange()"
                        [disabled]="isLoading"
                        [loading]="isLoading"
                        placeholder="Select trend line display option"
                      />
                    </div>
                  }
                </div>
              }

              @if(shouldDisplayToggleGrouped()) {
              <div class="d-flex align-items-center me-4">
                <p-checkbox
                  [(ngModel)]="isGrouped"
                  (ngModelChange)="onToggleGrouped()"
                  [binary]="true"
                  [style]="{ color: '#719eb6' }"
                  inputId="isGrouped"
                />
                <label
                  for="isGrouped"
                  style="font-weight: bold; color: #719eb6; margin-left: 0.5rem"
                  >Toggle Grouped/Synced Graph (If the y-axis ranges vary, the synced option might look better than the grouped.)</label
                >
              </div>
              }
            </div>
          </div>
        </div>
        }
      </div>

      <!-- Annotation Options -->
      <div class="col-12 col-lg-6">
        <label for="selectTarget" style="font-weight: bold; color: #719eb6">Annotations:</label>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <p-checkbox
                  [(ngModel)]="displayAnnotations"
                  (ngModelChange)="onDisplayAnnotationsChange()"
                  [binary]="true"
                  [style]="{'color': '#719eb6'}"
                  inputId="displayAnnotations"
                />
                <label for="displayAnnotations" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem">All Annotations</label> 
                <p-checkbox
                  class="ms-2"
                  [(ngModel)]="displayAutomaticAnnotations"
                  (ngModelChange)="onToggleAutomaticAnnotations()"
                  [binary]="true"
                  [style]="{'color': '#719eb6'}"
                  inputId="displayAnnotations"
                />
                <label for="displayAnnotations" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem">Automatic Annotations</label> 
                <p-checkbox
                  class="ms-2"
                  [(ngModel)]="displayUserAnnotations"
                  (ngModelChange)="onToggleUserAnnotations()"
                  [binary]="true"
                  [style]="{'color': '#719eb6'}"
                  inputId="displayAnnotations"
                />
                <label for="displayAnnotations" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem">User Annotations</label> 
              </div>
              <div class="card-body">
              <div class="annotation-list" style="height: 200px; overflow-y: auto;">
                @if (automaticAnnotations().length > 0) {
                  <div class="mb-2">
                    <div class="fw-bold mb-1" style="color: #719eb6">Automatic Annotations</div>
                    @for(annotation of automaticAnnotations(); track $index) {
                      <div class="d-flex align-items-center justify-content-between p-2 border-bottom">
                        <div class="d-flex align-items-center">
                          <p-checkbox 
                            [(ngModel)]="annotation.VisibleForUser"
                            [binary]="true"
                            [style]="{'color': '#719eb6'}"
                            (onChange)="onAnnotationVisibilityChange(annotation)"
                          />
                          <span class="ms-2" style="color: #719eb6">
                            {{ annotationLabel(annotation) }}
                          </span>
                        </div>
                        <button 
                          class="btn btn-link p-0"
                          [disabled]="true"
                        >
                          <i class="pi pi-pencil" style="color: #719eb6; opacity: 0.5"></i>
                        </button>
                      </div>
                    }
                  </div>
                }
                @if (userAnnotations().length > 0) {
                  <div>
                    <div class="fw-bold mb-1" style="color: #719eb6">Custom Annotations</div>
                    @for(annotation of userAnnotations(); track $index) {
                      <div class="d-flex align-items-center justify-content-between p-2 border-bottom">
                        <div class="d-flex align-items-center">
                          <p-checkbox 
                            [(ngModel)]="annotation.VisibleForUser"
                            [binary]="true"
                            [style]="{'color': '#719eb6'}"
                            (onChange)="onAnnotationVisibilityChange(annotation)"
                          />
                          <span class="ms-2" style="color: #719eb6">
                            {{ annotationLabel(annotation) }}
                          </span>
                        </div>
                        <button 
                          class="btn btn-link p-0"
                          (click)="editAnnotation(annotation)"
                        >
                          <i class="pi pi-pencil" style="color: #719eb6"></i>
                        </button>
                      </div>
                    }
                  </div>
                } 
                @if (automaticAnnotations().length == 0 && userAnnotations().length == 0) {
                  <div class="text-center p-3" style="color: #719eb6">
                    No annotations available
                  </div>
                }
              </div>
              </div>
            </div>
          </div>
          @if(shouldDisplayAddAnnotationButton()) {
          <div class="col-12">
            <button
              (click)="addAnnotationButtonClicked()"
              class="side-menu-button2 selected w-100 mt-2"
              id="addAnnotationButton"
            >
              + Annotation
            </button>
            </div>
          }
        </div>
      </div>
    </div>


    
  </div>

  <div
    class="card-body"
    style="padding-left: 2rem; padding-right: 2rem; padding-bottom: 2rem"
  >
    <!-- Graph -->
    @if(shouldDisplayGraph()) {
      @if(this.isGrouped()) {
        <apx-chart
        #chart
        [series]="chartOptions.series || []"
        [chart]="chartOptions.chart || { type: 'line' }"
        [xaxis]="chartOptions.xaxis || {}"
        [yaxis]="chartOptions.yaxis || {}"
        [title]="chartOptions.title || {}"
        [dataLabels]="chartOptions.dataLabels || {}"
        [grid]="chartOptions.grid || {}"
        [stroke]="chartOptions.stroke || {}"
        [labels]="chartOptions.labels || []"
        [annotations]="chartOptions.annotations || {}"
        [legend]="chartOptions.legend || {}"
        [markers]="chartOptions.markers || {}"
        [tooltip]="chartOptions.tooltip || {}"
        [responsive]="chartOptions.responsive || []"
        [plotOptions]="chartOptions.plotOptions || {}"
        [colors]="chartOptions.colors || []"
      ></apx-chart>
      } @else {
        @for(chartOptions of chartsOptions; track $index) {
          <apx-chart
          [series]="chartOptions.series || []"
          [chart]="chartOptions.chart || { type: 'line' }"
          [xaxis]="chartOptions.xaxis || {}"
          [yaxis]="chartOptions.yaxis || {}"
          [title]="chartOptions.title || {}"
          [dataLabels]="chartOptions.dataLabels || {}"
          [grid]="chartOptions.grid || {}"
          [stroke]="chartOptions.stroke || {}"
          [labels]="chartOptions.labels || []"
          [annotations]="chartOptions.annotations || {}"
          [legend]="chartOptions.legend || {}"
          [markers]="chartOptions.markers || {}"
          [tooltip]="chartOptions.tooltip || {}"
          [responsive]="chartOptions.responsive || []"
          [plotOptions]="chartOptions.plotOptions || {}"
          [colors]="chartOptions.colors || []"
          ></apx-chart>
        }
      }
    } @else {
    <div class="no-data">
      <p
        style="
          text-align: center;
          margin-top: 20px;
          font-size: 1rem;
          color: #719eb6;
        "
      >
        No data available for the selected program graph type.
      </p>
    </div>
    }
  </div>
</div>
